import { ModalDeletarBottomModule } from './components/modal-deletar-bottom/modal-deletar-bottom.module';
import { AppComponent } from 'app/app.component';
import { ModalCanalDenunciaAppComponent } from './components/modalCanalDenunciaApp/modalCanalDenunciaApp.component';

import { HeaderUserModule } from './components/header-user/header-user.module';

// import { DropzoneComponent } from '../layout/components/dropzone/dropzone.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { CustomBreakPointsProvider } from 'app/layout/custom-breakpoints';
import { VerticalLayoutModule } from 'app/layout/vertical/vertical-layout.module';
import { HorizontalLayoutModule } from 'app/layout/horizontal/horizontal-layout.module';
import { PaginationModule } from './components/pagination/pagination.module';
import { DropdownModule } from './components/dropdown/dropdown.module';
import { FormsModule } from '@angular/forms';
import { ModalDeletarModule } from './components/modal-deletar/modal-deletar.module';
import { ChartsModule } from 'ng2-charts';

import { StackedBarsComponent } from './components/stacked-bars/stacked-bars.component';
import { LineChartComponent } from './components/lineChart/lineChart.component';
import { ButtonsEditComponent } from './components/buttonsEdit/buttonsEdit.component';

import { CommonModule } from '@angular/common';
import { BotaoVoltarModule } from './components/botao-voltar/botao-voltar.module';
import { CardTreinamentosModule } from './components/card-treinamentos/card-treinamentos.module';
import { HeaderEnterpriseModule } from './components/header-enterprise/header-enterprise.module';

import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { StackedBarsAppComponent } from './components/stacked-bars-app/stacked-bars-app.component';
import { StackedBarsAppGraficComponent } from './components/stacked-bars-app-grafic/stacked-bars-app-grafic.component';
import { LoadingComponent } from './components/loading/loading.component';
import { StackedBarsForHomeComponent } from './components/stacked-bars-for-home/stacked-bars-for-home.component';
import { StackedBarsPolicieReportsComponent } from './components/stacked-bars-policie-reports/stacked-bars-policie-reports.component';
import { AmpPlayerComponent } from './components/amp-player/amp-player.component';
import { LoadingButtonComponent } from './components/loading-button/loading-button.component';
import { MessageNoDataComponent } from './components/message-no-data/message-no-data.component';
import { VideoLoadingComponent } from './components/video-loading/video-loading.component';

@NgModule({
  declarations: [
    StackedBarsComponent,
    LineChartComponent,
    ButtonsEditComponent,
    ModalCanalDenunciaAppComponent,
    StackedBarsAppComponent,
    StackedBarsAppGraficComponent,
    LoadingComponent,
    StackedBarsForHomeComponent,
    StackedBarsPolicieReportsComponent,
    AmpPlayerComponent,
    LoadingButtonComponent,
    MessageNoDataComponent,
    VideoLoadingComponent,
  ],
  imports: [
    CommonModule,
    FlexLayoutModule.withConfig({ disableDefaultBps: true }),
    VerticalLayoutModule,
    HorizontalLayoutModule,
    NgbModalModule,
    NgxDropzoneModule,
    PaginationModule,
    DropdownModule,
    FormsModule,
    ModalDeletarModule,
    ChartsModule,
  ],
  providers: [CustomBreakPointsProvider],
  exports: [
    VerticalLayoutModule,
    HorizontalLayoutModule,
    NgxDropzoneModule,
    ChartsModule,
    StackedBarsComponent,
    LineChartComponent,
    ButtonsEditComponent,
    HeaderEnterpriseModule,
    HeaderUserModule,
    BotaoVoltarModule,
    CardTreinamentosModule,
    ModalCanalDenunciaAppComponent,
    ModalDeletarBottomModule,
    PaginationModule,
    StackedBarsAppComponent,
    StackedBarsAppGraficComponent,
    StackedBarsForHomeComponent,
    LoadingComponent,
    StackedBarsPolicieReportsComponent,
    AmpPlayerComponent,
    LoadingButtonComponent,
    MessageNoDataComponent,
    VideoLoadingComponent,
  ],
})
export class LayoutModule {}

